import '../../Reports/reports.scss';

import { format, getQuarter } from 'date-fns';
import * as React from 'react';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';

import { IHistory } from '../../../interfaces';
import { PlantModel } from '../../../model/PlantModel';
import { RDatePicker } from '../../reusableComponents/DatePicker';
import { FooterCard } from './FooterCard'; 
import { Async } from '../../reusableComponents/Async';
import { ModalError } from '../../reusableComponents/ModalError';
import { ModalLoader } from '../../reusableComponents/ModalLoader';
import { getPlantDetails } from '../../../services/plantService';

export interface IListFooterProps {
    instances: PlantModel[];
    index: number;
    id: string;
    onClose: Function;
    history: IHistory;
}

export interface IListFooterState {
    date: Date;
    selectedDate: string;
    selectedOutfall: string;
    selectedQuarter: string;
    selectedYear: string;
    selectedRegion: string;
    showQuarterSelection: boolean;
    showOutFallSelection: boolean;
}

export class ListFooterImpl extends React.Component<IListFooterProps, IListFooterState> {

    constructor(props) {
        super(props);
        this.state = {
            showOutFallSelection: false,
            showQuarterSelection: false, date: new Date(), selectedDate: format(new Date(), 'MMMM YYYY'),
            selectedQuarter: getQuarter(new Date()).toString(),
            selectedYear: new Date().getFullYear().toString(),
            selectedRegion: 'All', selectedOutfall: ''
        };
    }

    dailyCheckList = '/summary-reports';
    monthlyCheckList = '/summary-reports/monthly';
    quarterlyCheckList = '/summary-reports/quarterly';

    static defaultProps: IListFooterProps;
    
    identifier = 'SummaryFooter';
    promise = async () => {
        if (!this.props.id) {
            return true;
        } 
        const instances = PlantModel.get(this.props.id); 
        await getPlantDetails(instances.props.PlantId); 
    }

    handleQuarterlyFormSelect = (formType) => {
        const { selectedOutfall, showQuarterSelection } = this.state;
        const { history: { push } } = this.props;
        const instances = PlantModel.get(this.props.id);
        const { PlantId, id } = instances.props;
        this.setState({
            showQuarterSelection: true,
            showOutFallSelection: (formType === 'QTRVisual' ? true : false)
        });

        if (formType !== 'ShopInspection' && (showQuarterSelection && (!selectedOutfall))) {
            toast.error('Please select an Outfall...!!!!', {
                position: toast.POSITION.TOP_RIGHT,
                className: 'failed-toast'
            });
        } else if (formType === 'QTRVisual' && (showQuarterSelection && !selectedOutfall)) {
            toast.error(`Sorry this plant is not allowed to fill Quarter Visual form.`, {
                position: toast.POSITION.TOP_RIGHT,
                className: 'failed-toast'
            });
        } else if (selectedOutfall) {
            /*tslint:disable-next-line */
            push(`${this.quarterlyCheckList}/${formType}/${PlantId}/${format(this.state.date, 'MM-DD-YYYY')}/${id}/${selectedOutfall || 'na'}`);

        } else if (formType === 'ShopInspection') {
            /*tslint:disable-next-line */
            push(`${this.quarterlyCheckList}/${formType}/${PlantId}/${format(this.state.date, 'MM-DD-YYYY')}/${id}/${selectedOutfall || 'na'}`);
        }
    }

    handleMonthlyFormSelect = (formType) => {
        const { history: { push } } = this.props;
        const instances = PlantModel.get(this.props.id);
        const { PlantId, id } = instances.props;
        this.setState({
            showQuarterSelection: false
        });
        push(`${this.monthlyCheckList}/${formType}/${PlantId}/${format(this.state.date, 'MM-DD-YYYY')}/${id}`);
    }

    handleDailyFormSelect = (formType) => {
        const { history: { push } } = this.props;
        const instances = PlantModel.get(this.props.id);
        const { PlantId, id } = instances.props;
        this.setState({
            showQuarterSelection: false
        });
        push(`${this.dailyCheckList}/${formType}/${PlantId}/${format(this.state.date, 'MMYYYY')}/${id}`);
    }

    getOutFalls = () => {
        const { props: { Outfalls } } = PlantModel.get(this.props.id);
        const outFalls = [];
        let i = 1;
        for (const key in Outfalls) {
            if (Outfalls[key]) {
                outFalls.push({
                    key, value: i,
                });
            }
            i++;
        }
        return outFalls;
    }

    renderContent() {
        const { history: { push } } = this.props;
        const instances = PlantModel.get(this.props.id);
        if (!instances) {
            return <span />;
        }
        const { Plant_Region, PlantId, Inspections } = instances.props;
        return (
            <div className="list-footer-monthly" >
                <div className="date-filter">
                    {this.state.showOutFallSelection ?
                        <select key={3} onChange={e => this.setState({ selectedOutfall: e.target.value })} >
                            <option value="" selected disabled >Outfall</option>
                            {this.getOutFalls().map((outFall, index) => {
                                return <option
                                    className={outFall.className}
                                    key={index}
                                    value={outFall.value}
                                >
                                    {outFall.key}
                                </option>;

                            })}
                        </select> : ''}
                </div>
                <div className="header">
                    Summary Reports for Plant {PlantId} of Region {Plant_Region}
                    <span onClick={() => this.props.onClose()} >X</span>
                </div>
                <div className="plant-info" >
                    PlantID:
                        <span
                        className="info-value"
                    >
                        &nbsp; {PlantId}
                    </span>
                </div>
                
                <div className="list-footer-container" style={{ display: 'flex' }} >
                    <div className="main-container" >
                        <div className="title" >
                            <span> Daily Forms </span>
                        </div>
                        <div className="card-container">
                            <FooterCard
                                isVisible={Inspections.DailyForm}
                                id="DailyForm"
                                onClick={this.handleDailyFormSelect}
                                isClickable={true}
                                plantUID={PlantId}
                                label={<span>Daily <br /> Form</span>}
                                date={this.state.date}
                            />
                            <FooterCard
                                isVisible={Inspections.PlantPreventive}
                                id="PlantPreventive"
                                onClick={this.handleDailyFormSelect}
                                isClickable={true}
                                plantUID={PlantId}
                                label={<span>Plant <br /> Preventive</span>}
                                date={this.state.date}
                            />
                        </div>
                    </div>
                    <div className="main-container" >
                        <div className="title" >
                            <span> Monthly Forms </span>
                        </div>
                        <div className="card-container">
                            <FooterCard
                                isVisible={Inspections.MonthlySW}
                                id="MonthlySW"
                                onClick={this.handleMonthlyFormSelect}
                                isClickable={true}
                                plantUID={PlantId}
                                label={<span>Monthly <br /> SW</span>}
                                date={this.state.date}
                            />
                            <FooterCard
                                isVisible={Inspections.MonthlySPCC}
                                id="MonthlySPCC"
                                onClick={this.handleMonthlyFormSelect}
                                isClickable={true}
                                plantUID={PlantId}
                                label={<span>Monthly <br /> SPCC</span>}
                                date={this.state.date}
                            />
                            <FooterCard
                                isVisible={Inspections.MonthlyUSTSpill}
                                id="MonthlyUSTSpill"
                                onClick={this.handleMonthlyFormSelect}
                                isClickable={true}
                                plantUID={PlantId}
                                label={<span>UST Spill <br /> Container</span>}
                                date={this.state.date}
                            />
                            <FooterCard
                                isVisible={Inspections.MonthlyUSTRect}
                                id="MonthlyUSTRect"
                                onClick={this.handleMonthlyFormSelect}
                                isClickable={true}
                                plantUID={PlantId}
                                label={<span>UST <br />  Rectifier</span>}
                                date={this.state.date}
                            />
                            <FooterCard
                                isVisible={Inspections.MonthlySpillLogs}
                                id="MonthlySpillLogs"
                                onClick={this.handleMonthlyFormSelect}
                                isClickable={true}
                                plantUID={PlantId}
                                label={<span>Spills &amp; <br />Leaks</span>}
                                date={this.state.date}
                            />
                        </div>
                    </div>
                    <div className="main-container" >
                        <div className="title" >
                            <span> Quarterly Forms </span>
                        </div>
                        <div className="card-container">
                            <FooterCard
                                isVisible={Inspections.QTRVisual}
                                id="QTRVisual"
                                onClick={this.handleQuarterlyFormSelect}
                                isClickable={true}
                                plantUID={PlantId}
                                label={<span>Visual <br /> Reports</span>}
                                date={this.state.date}
                            />
                            <FooterCard
                                isVisible={Inspections.ShopInspection}
                                id="ShopInspection"
                                onClick={this.handleQuarterlyFormSelect}
                                isClickable={true}
                                plantUID={PlantId}
                                label={<span>Shop <br /> Inspection</span>}
                                date={this.state.date}
                            />
                        </div>
                    </div>
                </div>
            </div>);
    }
    render(){
        const instances = PlantModel.get(this.props.id);
        const { date, selectedDate } = this.state;
        if (!instances) {
            return <span />;
        }
        return ( 
                <Async
                    identifier={this.identifier}
                    promise={this.promise}
                    loader={<ModalLoader />}
                    content={this.renderContent()}
                    error={<ModalError />}
                />  );
    }

}

export const ListFooter = withRouter(ListFooterImpl);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Summary/ListPage/ListFooter.tsx